import { render, staticRenderFns } from "./JobComponent.vue?vue&type=template&id=465b5f0d&scoped=true"
import script from "./JobComponent.vue?vue&type=script&lang=ts"
export * from "./JobComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465b5f0d",
  null
  
)

export default component.exports